<mat-card *ngIf="assetStatus$ | async as status; else loadingCardTemplate" class="card" [style.width.px]="width"
    [class]="[status.state.code | lowercase]">
    <mat-card-title class="line">
        <div class="content title">
            {{ status.asset.description }}
        </div>
        <app-status-indicator class="indicator" [state]="status.state.code | lowercase">
            <span content>{{ status.state.description }}</span>
        </app-status-indicator>
    </mat-card-title>
    <mat-card-content class="card-content">
        <div class="line">
            <div class="content description">
                {{ status.asset.manufacturer }} {{ status.asset.name }}
            </div>
        </div>
    </mat-card-content>

    <ng-container *ngIf="image$ | async as image; else loadingImageTemplate">
        <img mat-card-image [src]="image.source" alt="image" />
    </ng-container>

    <mat-card-content class="card-content">
        <div class="line elapsed-time" *ngIf="status.elapsedTime">
            {{ status.elapsedTime }}
        </div>
        <ng-container *ngIf="status.alerts.length">
            <div class="line elapsed-time" *ngFor="let alert of status.alerts" ellipsifyContent>
                <mat-icon class="material-icons-outlined icon" [class]="alert.severity">priority_high</mat-icon>
                <span>{{ alert.elapsedTime }}</span>
            </div>
        </ng-container>
    </mat-card-content>

    <mat-divider></mat-divider>

    <mat-card-actions class="actions">
        <button mat-button *ngIf="status.hasCategories" (click)="onRedirectToAssetExplore(status)">
            EXPLORE
        </button>
        <button mat-button (click)="onRedirectToAssetDetail(status.asset.id)">ASSET DETAIL</button>
        <button mat-button (click)="onOpenAssetEventsMonitoring(status.asset.id)">LIVE</button>
    </mat-card-actions>
</mat-card>

<ng-template #loadingCardTemplate>
    <mat-card class="card" [style.width.px]="width">
        <mat-card-title>
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
        </mat-card-title>
        <mat-card-content style="padding-left: 0; padding-right: 0">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
        </mat-card-content>
        <ng-template *ngTemplateOutlet="loadingImageTemplate"></ng-template>
        <mat-card-content style="padding-left: 0; padding-right: 0">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
        </mat-card-content>
        <mat-card-actions class="actions">
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ width: '100px' }"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ width: '100px' }"></ngx-skeleton-loader>
        </mat-card-actions>
    </mat-card>
</ng-template>

<ng-template #loadingImageTemplate>
    <ngx-skeleton-loader count="1" appearance="line" [theme]="{
            width: '100%',
            height: '150px'
        }"></ngx-skeleton-loader>
</ng-template>